// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PersonNameResponse } from './person-name-response';

/** See com.rev360.pms.api.controller.encounter.review.EncounterReviewGeneralInformationResponse */
/* istanbul ignore next */
@GandalfModel
export class EncounterReviewGeneralInformationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	contactLensRxCount!: number | null;

	@GandalfProperty({ designType: Number })
	contactLensTrialCount!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	encounterDate!: Date | null;

	@GandalfConstantDecorator(constants.EncounterStatus)
	@GandalfProperty({ designType: constants.EncounterStatus })
	encounterStatus!: constants.EncounterStatus | null;

	@GandalfProperty({ designType: String })
	encounterType!: string | null;

	@GandalfProperty({ designType: Number })
	eyeglassRxCount!: number | null;

	@GandalfProperty({ designType: String })
	patientRfv!: string | null;

	@GandalfArray(String)
	primaryMedicalProviders!: string[] | null;

	@GandalfArray(String)
	primaryVisionProviders!: string[] | null;

	@GandalfProperty({ designType: PersonNameResponse })
	providerName!: PersonNameResponse | null;

	@GandalfProperty({ designType: String })
	providerRfv!: string | null;

	@GandalfArray(String)
	serviceDetails!: string[] | null;

}
